module.exports = __webpack_public_path__ + "img/4.788b7f39.png";